module.exports = __webpack_public_path__ + "img/frame (287).cc237fd5.jpg";